<p-toast position="top-right"></p-toast>
<app-confirm-dialog
  [visible]="confirmationDialogVisible"
  variant="secondary"
  heading="Confirmation"
  [message]="confirmationDialogMessage"
  cancelText="No"
  (confirmed)="confirmConfirmationDialog()"
  (cancelled)="cancelConfirmationDialog()">
</app-confirm-dialog>
<div class="p-g create-Branch-Responsive">
   <!-- <div class="signin_btn">
      <button pButton type="submit" icon="p-icon-person" routerLink="/login" label="Sign In" style="width: 100%"
         icon="p-icon-person"></button>
   </div> -->
   <div class="p-g-12">
      <p-tabView>

         <!-- branch tab -->
         <p-tabPanel [header]='setLabel("branchHeaderLabel")' [disabled]="true" [selected]="indextab==0">
            <form [formGroup]="branchForm" #branchformDir>
               <div [hidden]="branchformDir.submitted">
                  <div class="p-g" style="min-height: 55vh;">
                     <div class="p-g-12" style="text-align: center;">
                        <img src="assets/layout/images/gym.png">
                        <br>
                        <h2>{{setLabel("branchInformationLabel")}}</h2>
                     </div>
                     <!-- style="    display: flex;
                     flex-direction: column;
                     justify-content: center;
                     align-items: center;" -->
                     <div class="p-g-12 input-Main">
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <input type="text" name="branchname" id="branchname" formControlName="branchname" required
                                 autocomplete="off" pInputText style="width: 100%;;">
                              <div *ngIf="branchname.invalid && (branchname.dirty || branchname.touched)"
                                 class="input-error">
                                 <div *ngIf="branchname.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("branchNameProceedErrorLabel")}}
                                 </div>
                              </div>
                              <label>
                                 {{setLabel("branchNameLabel")}}
                                 <span class="asterisk">*</span></label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <input type="text" name="branchaddress" formControlName="branchaddress" id="branchaddress"
                                 autocomplete="off" pInputText required style="width: 100%;;">
                              <div *ngIf="branchaddress.invalid && (branchaddress.dirty || branchaddress.touched)"
                                 class="input-error">
                                 <div *ngIf="branchaddress.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("branchAddressProceedErrorLabel")}}</div>
                              </div>
                              <label>{{setLabel("addressLabel")}}
                                 <span class="asterisk">*</span>

                              </label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <app-phone-input
                                 id="branchphone"
                                 formControlName="branchphone"
                                 [placeholder]="setLabel('contactNoLabel')"
                                 [required]="true">
                              </app-phone-input>
                              <label>{{setLabel("contactNoLabel")}}
                                 <span class="asterisk">*</span>
                              </label>
                           </span>
                        </div>
                     <!-- </div> -->
                     <!-- <div class="p-g-12 input-Main"> -->
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <input type="text" name="branchcontactPerson" id="branchcontactPerson"
                                 style="width: 100%;;" formControlName="branchcontactPerson" autocomplete="off"
                                 pInputText>
                              <label>{{setLabel("contactPersonLabel")}}</label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <input type="text" name="branchcontactPersonEmail" id="branchcontactPersonEmail"
                                 style="width: 100%;;" formControlName="branchcontactPersonEmail" autocomplete="off"
                                 pInputText required>
                              <div
                                 *ngIf="branchcontactPersonEmail.invalid && (branchcontactPersonEmail.dirty || branchcontactPersonEmail.touched)"
                                 class="input-error">
                                 <div *ngIf="branchcontactPersonEmail.errors.pattern"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("validEmailErrorLabel")}}
                                 </div>
                                 <div *ngIf="branchcontactPersonEmail.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("emailProceedErrorLabel")}}
                                 </div>
                              </div>
                              <label>{{setLabel("contactEmailLabel")}}
                                 <span class="asterisk">*</span>

                              </label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <input type="text" name="domainname" id="domainname" formControlName="domainname" required
                                 autocomplete="off" pInputText style="width: 100%;;">
                              <div *ngIf="domainname.invalid && (domainname.dirty || domainname.touched)"
                                 class="input-error">
                                 <div *ngIf="domainname.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("domainNameErrorLabel")}}
                                 </div>
                              </div>
                              <label>{{setLabel("domainNameLabel")}}
                                 <span class="asterisk">*</span>

                              </label>
                           </span>
                        </div>
                     <!-- </div> -->
                     <!-- <div class="p-g-12 input-Main"> -->
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <app-phone-input
                                 id="whatsapp"
                                 formControlName="whatsapp"
                                 [placeholder]="setLabel('whatsAppNumberLabel')"
                                 [required]="true">
                              </app-phone-input>
                              <label>{{setLabel("whatsAppNumberLabel")}}
                                 <span class="asterisk">*</span>
                              </label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <app-phone-input
                                 id="registrationwhatsapp"
                                 formControlName="registrationwhatsapp"
                                 [placeholder]="setLabel('registrationWhatsAppNumberLabel')"
                                 [required]="false">
                              </app-phone-input>
                              <label>{{setLabel("registrationWhatsAppNumberLabel")}}</label>
                           </span>
                        </div>
                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span class="md-inputfield">
                              <app-phone-input
                                 id="visitorwhatsapp"
                                 formControlName="visitorwhatsapp"
                                 [placeholder]="setLabel('visitorWhatsAppNumberLabel')"
                                 [required]="false">
                              </app-phone-input>
                              <label>{{setLabel("visitorWhatsAppNumberLabel")}}</label>
                           </span>
                        </div>
                     <!-- </div> -->
                     <div class="p-g-12 p-md-6 p-lg-4">
                        <span class="md-inputfield">
                           <app-phone-input
                              id="feewhatsapp"
                              formControlName="feewhatsapp"
                              [placeholder]="setLabel('feeWhatsAppNumberLabel')"
                              [required]="false">
                           </app-phone-input>
                           <label>{{setLabel("feeWhatsAppNumberLabel")}}</label>
                        </span>
                     </div>

                        <div class="p-g-12 p-md-6 p-lg-4">
                           <span style="display: flex;width: 100%;align-items: center;">
                              <label style="color: #706f6f;margin-right: 2em;">Gym Package
                                 <span class="asterisk">*</span>
                              </label>
                              <select style="width: 7rem;height: 1.8rem;" name="gymPackage" id="gymPackage" formControlName="gymPackage"
                                 required>
                                 <option value="standard" selected>Standard</option>
                                 <option value="premium">Premium</option>
                                 <option value="enterprise">Enterprise</option>
                              </select>
                           </span>
                        </div>

                     <div class="p-g-12">
                        <br>
                        <div class="p-g-4"></div>
                        <div class="p-g-4">
                           <button pButton type="button" id="branchNextButton" (click)="nextform(branchForm)"
                              [label]='setLabel("nextLabel")' style="width: 100%"></button>
                        </div>
                        <div class="p-g-4"></div>
                     </div>
                  </div>
                  </div>
               </div>
            </form>
         </p-tabPanel>

         <!-- User tab -->
         <p-tabPanel [header]='setLabel("userHeaderLabel")' [disabled]="true" [selected]="indextab==1">
            <form [formGroup]="userForm" #userformDir>
               <div [hidden]="userformDir.submitted">
                  <div class="p-g" style="min-height: 54vh;">
                     <div class="p-g-12" style="text-align: center;">
                        <img src="assets/layout/images/gym.png">
                        <br>
                        <h2>{{setLabel("userInformationLabel")}}</h2>
                     </div>
                     <div class="User-Input-Main">
                     <div class="p-g-12 p-md-6 p-lg-4">
                        <div class="p-g-12"></div>
                        <div class="p-g-12">
                           <span class="md-inputfield">
                              <input type="text" name="fullname" id="fullname" formControlName="fullname" required
                                 autocomplete="off" pInputText style="width: 100%;">
                              <div *ngIf="fullname.invalid && (fullname.dirty || fullname.touched)" class="input-error">
                                 <div *ngIf="fullname.errors.required"
                                    style="text-align: start; color: red; font-size: small;">
                                    {{setLabel("nameProceedErrorLabel")}}
                                 </div>
                              </div>
                              <label>{{setLabel("nameLabel")}}</label>
                           </span>
                        </div>
                        <div class="p-g-4"></div>
                     </div>
                     <div class="p-g-12 p-md-6 p-lg-4">
                        <div class="p-g-12"></div>
                        <div class="p-g-10">
                           <span class="md-inputfield">
                              <input type="email" name="username" id="username" formControlName="username"
                                 autocomplete="off" pInputText style="width: 100%;">
                              <div *ngIf="username.invalid && (username.dirty || username.touched)" class="input-error">
                                 <div *ngIf="username.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("userNameRequiredLabel")}}
                                 </div>
                                 <div *ngIf="username.errors.pattern"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("correctUsernameErrorLabel")}}
                                 </div>
                              </div>
                              <label>{{setLabel("userNameLabel")}}</label>
                           </span>
                        </div>
                        <label>{{setLabel("@Label")}}{{userdomain}}</label>
                        <!-- <div class="p-g-4"></div> -->
                     </div>
                     <div class="p-g-12 p-md-6 p-lg-4">
                        <div class="p-g-4"></div>
                        <div class="p-g-12">
                           <span class="md-inputfield">
                              <input type="text" name="password" id="password" formControlName="password"
                                 autocomplete="off" pInputText style="width: 100%;">
                              <div *ngIf="password.invalid && (password.dirty || password.touched)" class="input-error">
                                 <div *ngIf="password.errors.required"
                                    style="text-align: left; color: red; font-size: small;">
                                    {{setLabel("passwordRequiredErrorLabel")}}
                                 </div>
                              </div>
                              <label>{{setLabel("passwordLabel")}}</label>
                           </span>
                        </div>
                        <div class="p-g-4"></div>
                     </div>
                     <div class="p-g-12">
                        <br>
                        <div class="p-g-4"></div>
                        <div class="p-g-4">
                           <button pButton type="button" id="registerButton" (click)="registerBranch(userForm)"
                              [label]='setLabel("registerLabel")' style="width: 100%"></button>
                        </div>
                        <div class="p-g-4"></div>
                     </div>
                  </div>
                  </div>
               </div>
            </form>
         </p-tabPanel>
      </p-tabView>
   </div>
</div>
